// Shared <Menu> sx, matched to the account menu so every dropdown reads as one
// family. Apply via `sx={menuSurfaceSx}`.
export const menuSurfaceSx = {
  "&& .MuiPaper-root": {
    borderRadius: "16px !important",
    padding: "8px !important",
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12) !important",
  },
  "&& .MuiMenuItem-root": {
    borderRadius: "8px",
  },
} as const;
